import React from "react";

export default function HoursService({ name }) {
  return (
    <div>
      <h4 style={{ textAlign: "center" }}>
        Hours of Service Policy Acknowledgement
      </h4>
      <p>
        I {name ? <b>{name}</b> : ""}acknowledge that I have been trained in the
        Hours-of-Service Regulations as they pertain to a Commercial Motor
        Vehicle driver in Canada and the United States (Regulations 555/06 of
        the Highway Traffic Act and Regulation 395 of FMCSR.)
      </p>
      <p>
        I further acknowledge that I will adhere to these regulations and follow
        them to the letter as per the jurisdiction that I am operating in.
      </p>
      <p>
        It is understood that the company will, at all times, monitor my
        compliance with Hours-of-Service regulations and in the event of
        non-compliance I will face disciplinary action and remedial training and
        upon discovery of repeated violations I may be subject to dismissal.
      </p>
    </div>
  );
}
